module.exports = __webpack_public_path__ + "static/media/sass.9b37bc9e.png";